import React, { useContext } from 'react';
import { Button, Card, CardTitle, CardBody, CardActions, } from '@one-thd/sui-atomic-components';
import { CodeFullDetailDescription } from '../commons';
import { modalBlurbs } from '../../../../../constants/NationalAccount';
import { NationalAccountContext } from '../../../../../contexts';
import { stashLinkEvent } from '../../../../../utils/analytics';
export var AlreadyEnrolledSummary = function () {
    var setShowModal = useContext(NationalAccountContext).setShowModal;
    var unenrollBlurbs = modalBlurbs.unenroll;
    var AgreementDescription = function () {
        return (React.createElement("div", { "data-testid": "agreementDescription", className: "sui-text-base lg:sui-text-lg sui-py-4 md:sui-py-0 md:sui-pr-4" },
            React.createElement("div", null,
                React.createElement("p", { "data-testid": "alignTextAndLink", className: "sui-mb-4" }, unenrollBlurbs.agreementDescription.line1),
                React.createElement("div", { className: "sui-pt-2 sui-pb-10 md:sui-pb-4" },
                    unenrollBlurbs.agreementDescription.line2,
                    ' ',
                    React.createElement("a", { className: "sui-inline-block sui-underline", onClick: function () {
                            stashLinkEvent('pricing benefits: national account incentives: cards and accounts link');
                        }, href: unenrollBlurbs.cardsAndAccountsLink }, "Cards & Accounts page"),
                    '. ',
                    unenrollBlurbs.agreementDescription.line3)),
            React.createElement("div", null,
                React.createElement(Button, { variant: "text", onClick: function () {
                        window.open(unenrollBlurbs.rebate, '_blank', 'noopener,noreferrer');
                        stashLinkEvent('pricing benefits: national account incentives: terms and conditions link');
                    }, "data-testid": "tocButton" },
                    React.createElement("span", { className: "sui-block" },
                        React.createElement("span", { className: "sui-inline-block sui-pr-1" }, unenrollBlurbs.termsAndConditions[0]),
                        React.createElement("span", { className: "sui-inline-block" }, unenrollBlurbs.termsAndConditions[1]))))));
    };
    var AgreementSummary = function () {
        return (React.createElement(Card, { "data-testid": "agreementBox", CardContentProps: { grow: true } },
            React.createElement(CardTitle, { header: "Agreement Details", headerWeight: "bold" }),
            React.createElement(CardBody, null,
                React.createElement(CodeFullDetailDescription, null)),
            React.createElement(CardActions, null,
                React.createElement(Button, { variant: "text", onClick: function () { return setShowModal(true); } }, unenrollBlurbs.buttons.unenroll))));
    };
    return (React.createElement("div", { "data-testid": "alreadyEnrolledSummary", className: "sui-pt-5 sui-flex sui-flex-col sui-flex-col-reverse sui-gap-4 md:sui-grid md:sui-grid-cols-2" },
        React.createElement(AgreementDescription, null),
        React.createElement(AgreementSummary, null)));
};
